module.exports = __webpack_public_path__ + "public/images/plus-gray.5f9641dc19bade217a17fd74a6df05dc.svg";